/**
 * @generated SignedSource<<c59e3d9fe824c793d8469a9e8be7dc1e>>
 * @relayHash c97066ea9133e252df98e2a71427ae7f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d2fb876a7e3dc7853483baab5b740175f5f9ee911bca5bb40564c8664dd6cf30

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessOverviewCalendarQuery } from './src_jiraBusinessOverviewCalendarQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessOverviewCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "d2fb876a7e3dc7853483baab5b740175f5f9ee911bca5bb40564c8664dd6cf30",
    "metadata": {},
    "name": "src_jiraBusinessOverviewCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
